import featureFlags from "@/util/featureFlags";
import dayjs from "@/util/dayjs";
import EncryptedFile from "@/models/EncryptedFile";

export default class PricingCalculator {

  static uploadIsInFreeTier(files: File[] | EncryptedFile[], expiry: Date) {
    const size = this.getCombinedFilesizeOfFiles(files);
    const defaultExpiry = dayjs().add(featureFlags.defaultExpiryInDays, "days").toDate();
    return size <= featureFlags.freeTierTransferLimit &&
      files.length <= featureFlags.freeTierFileLimit &&
      dayjs(this.getFixedExpiryDate(expiry)).isSame(this.getFixedExpiryDate(defaultExpiry));
  }

  static getEstimatedTokenCostOfUploadWithTimestamps(files: File[] | EncryptedFile[], start: Date, expiry: Date) {
    const size = this.getCombinedFilesizeOfFiles(files);
    const daysUntilExpiry =  Math.floor(dayjs(expiry).diff(start, "days")); //Use floor since we always grant up to one day more, since links expire on the end of a day

    const tokensForSize =  Math.ceil(size / featureFlags.transferBillingUnit);
    const timeUnitsForExpiry = Math.ceil(daysUntilExpiry / featureFlags.billingPeriodInDays);
    return tokensForSize * timeUnitsForExpiry;
  }

  static getEstimatedTokenCostOfUpload(files: File[] | EncryptedFile[], expiry: Date) {
    return this.getEstimatedTokenCostOfUploadWithTimestamps(files, new Date(), expiry);
  }

  //Always expire upload on end of date!
  static getFixedExpiryDate(expiry: Date): Date {
    return dayjs(expiry).endOf("day").toDate();
  }

  static getCombinedFilesizeOfFiles(files: File[] | EncryptedFile[]): number {
    let size = 0;
    for (const file of files) {
      size += file.size;
    }
    return size;
  }
}
